import { render, staticRenderFns } from "./own-payman.vue?vue&type=template&id=c5246922&"
import script from "./own-payman.vue?vue&type=script&lang=js&"
export * from "./own-payman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports